import React from "react";
import { Navigate } from "react-router-dom";
import useAuthChecker from "../../../Logic/useAuthChecker";
import Menu from "../Menu";

const CommonLayout = ({ children, className }) => {
  const { isAuthCompleted } = useAuthChecker();

  return isAuthCompleted ? (
    <div className={className}>
      <Menu />
      {children}
    </div>
  ) : (
    <Navigate to="/" />
  );
};

export default CommonLayout;
